const styles = {
  root: {
    position: "fixed",
    zIndex: 100,
    pointerEvents: "none",
  },
};

export default styles;
